import { FC } from 'react';
import { useInspectionPages } from '../../../services/inspection';
import { ProgressBar } from '../../../components/ProgressBar';
import styles from './QuestionnaireProgress.module.css';

interface QuestionnaireProgressProps {}

export const QuestionnaireProgress: FC<QuestionnaireProgressProps> = () => {
  const { current, total } = useInspectionPages();
  const progress = current + 1;

  return (
    <div className={styles.progress}>
      <div>
        {progress} / {total}
      </div>
      <ProgressBar progress={progress} total={total} />
    </div>
  );
};
